import { render, staticRenderFns } from "./Dialog2.vue?vue&type=template&id=e4112212&"
import script from "./Dialog2.vue?vue&type=script&lang=js&"
export * from "./Dialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports